import { Divider, Link } from '@fluentui/react-components';
import React from 'react';
import { useFooterStyles } from './Footer.styles';

/** Very bottom of the app*/
export const Footer = () => {
  const styles = useFooterStyles();
  return (
    <footer>
      <Divider />
      <div className={styles.footer}>
        <Link href={__DATA_PRIVACY_NOTICE_LINK__} target="_blank" className={styles.link}>
          Microsoft Data Privacy Notice
        </Link>
        <div>&copy; 2024 Microsoft</div>
      </div>
    </footer>
  );
};
